// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
/* tslint:disable */
/* eslint-disable */
import "../textstyles/fonts.css";
import "../reset.css";
import "./Tabs.css";
import React, { createContext, useContext } from "react";
import {
  findSetVariantProps,
  makeCompositeDefaultProps,
} from "../_internal_utils";
import { ContainerPrimitive } from "../_internal_primitives";
import { RadioGroupRoot } from "../_internal_radio_group";

const styles = [
  {
    type: "default",
    layers: {},
  },
];

const defaultPropValues = [
  {
    type: "default",
    layers: {},
  },
];

const variantPropTypes = [];

export const TabsContext = createContext(null);

function Tabs(_props) {
  const defaults = useContext(TabsContext);
  const props = { ...defaults, ..._props };
  const activeVariants = findSetVariantProps(variantPropTypes, props);
  const getCompositeDefaultProps = makeCompositeDefaultProps(
    defaultPropValues,
    activeVariants
  );
  return (
    <RadioGroupRoot
      {...props}
      key="segmented-control-root"
      addSpacing={false}
      internal={{
        projectId: "7X7HTLRqyD",
        styles: styles,
        layerId: "segmented-control-root",
        scope: "EoMKL9kJjZ",
        activeVariants: activeVariants,
      }}
    >
      {(getStyle) => (
        <ContainerPrimitive
          id={"ButtonContainer_6g1TWD6jEk"}
          className={
            "__visly_reset_7X7HTLRqyD __visly_scope_EoMKL9kJjZ_6g1TWD6jEk"
          }
          key={"6g1TWD6jEk"}
          addSpacing={true}
          element={getStyle("6g1TWD6jEk", "htmlElement")}
        >
          {props.children}
        </ContainerPrimitive>
      )}
    </RadioGroupRoot>
  );
}

Tabs.__variants = [];

export default Tabs;
